import { MonoTypeOperatorFunction, of, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export function debounceTrue(delayMs = 250): MonoTypeOperatorFunction<boolean> {
  return (source$) => source$.pipe(switchMap((value) => (value ? timer(delayMs).pipe(map(() => true)) : of(false))));
}
